// Pig Butchering / Crypto behavioral screening question bank.
// Extracted verbatim from the pre-refactor CryptocurrencyAssessment.js so the
// screening logic is unchanged; shape: { question, weight, options[{text, points}] }.
// Multi-select questions are flagged by '(Select all that apply)' in the text.
export const PIG_BUTCHERING_CRYPTO_QUESTIONS = [
  {
    question: "How was the contact initiated?",
    weight: 5,
    options: [
      { text: "I Initiated it to learn more about investing.", points: 1 },
      { text: "Contact me by email, text, social media, or dating site.", points: 5 }
    ]
  },
  {
    question: "Select the primary motivation for this investment? (Select all that apply)",
    weight: 11,
    options: [
      { text: "To make money to payoff debt.", points: 5 },
      { text: "Additional monthly income", points: 5 },
      { text: "Investment is a hobby.", points: 1 }
    ]
  },
  {
    question: "What is the primary source of the funds being invested? (Select all that apply)",
    weight: 20,
    options: [
      { text: "Previous investment profits from other investments.", points: 4 },
      { text: "401K Retirement funds", points: 4 },
      { text: "Converting stocks and bonds for reinvestment.", points: 4 },
      { text: "Home equity, line of credit", points: 4 },
      { text: "Personal saving", points: 4 }
    ]
  },
  {
    question: "Is there any romance involved with the person providing investment guidance?",
    weight: 5,
    options: [
      { text: "Yes, he/she is an expert", points: 5 },
      { text: "No, I keep my investment separate", points: 1 }
    ]
  },
  {
    question: "Rate your understanding of Blockchain, digital wallet, mining or Bitcoin?",
    weight: 5,
    options: [
      { text: "Expert", points: 1 },
      { text: "Advanced", points: 1 },
      { text: "Intermediate", points: 1 },
      { text: "Novice", points: 2 }
    ]
  },
  {
    question: "You are given show-in-tell to illustrate how easy and profitable investing in crypto is?",
    weight: 5,
    options: [
      { text: "Yes", points: 5 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Have you been promised or guarantee profits or big returns on your investment?",
    weight: 5,
    options: [
      { text: "Yes", points: 5 },
      { text: "No, all investment have a risk.", points: 1 }
    ]
  },
  {
    question: "Have you been encouraged to download a specific investing app and create an account for this investment?",
    weight: 5,
    options: [
      { text: "Yes, makes easier to keep up with how my investments is doing.", points: 5 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Have you been encouraged, invited or attend group chats dealing with investing?",
    weight: 5,
    options: [
      { text: "Yes, we discuss different investment strategies.", points: 5 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Select the amount investment you intend or have invest?",
    weight: 1,
    options: [
      { text: "$1 - $10,000", points: 1 },
      { text: "$11,000 - $50,000", points: 1 },
      { text: "$51,000 - $100,000", points: 1 },
      { text: "over $100,000", points: 1 }
    ]
  },
  {
    question: "Have you been told of any administrative penalties, taxes or fees you'll need to pay to withdraw your profits?",
    weight: 2,
    options: [
      { text: "Yes", points: 2 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Does the crypto platform have different investment levels for different investment amounts?",
    weight: 2,
    options: [
      { text: "Yes", points: 3 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Have you been encouraged/pressured to quickly act - time sensitive?",
    weight: 2,
    options: [
      { text: "Yes", points: 3 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Have you ever received any profits from your investment?",
    weight: 4,
    options: [
      { text: "Yes, saw a good investment return off my first investment.", points: 4 },
      { text: "Not yet.", points: 2 },
      { text: "No, I have not invested any funds.", points: 1 }
    ]
  },
  {
    question: "If you're re-investing initial profit have you been encourage or add additional money for larger return to reach your goal?",
    weight: 5,
    options: [
      { text: "Yes", points: 5 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Have you been shown a trading dashboard showing your financial gains?",
    weight: 5,
    options: [
      { text: "Yes, very cool to see my investment grow.", points: 5 },
      { text: "No, I have not invested.", points: 1 }
    ]
  },
  {
    question: "Does the crypto advisor represent a new or established businesses that offering their own crypto coins or tokens?",
    weight: 2,
    options: [
      { text: "Yes, can get in on the ground floor", points: 2 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "To your knowledge does cryptocurrency payments have consumer protection like credit or debit card?",
    weight: 2,
    options: [
      { text: "Yes", points: 2 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "Has your advisor indicated cryptocurrency payments can be reversed?",
    weight: 3,
    options: [
      { text: "Yes", points: 3 },
      { text: "No", points: 1 }
    ]
  },
  {
    question: "At any point have you been able to do a video chats with group or the advisor?",
    weight: 3,
    options: [
      { text: "Yes", points: 1 },
      { text: "No, always run into some type of issue.", points: 3 }
    ]
  },
  {
    question: "Does their social media convey a successful glamorous lifestyle?",
    weight: 3,
    options: [
      { text: "Yes", points: 3 },
      { text: "No", points: 1 },
      { text: "No social media profile", points: 1 }
    ]
  }
];

